<div class="fixed left-0 top-0 z-40 h-full w-full bg-transparent" *ngIf="show" (click)="onOverlayClicked()">
  <div
    *ngIf="parentBoundingBoxInPx()"
    class="fixed z-50 bg-transparent"
    (click)="dismissed.emit()"
    (mouseleave)="onMouseLeaveParentBoundingBoxSimulated()"
    [style.left]="parentBoundingBoxInPx()?.left"
    [style.top]="parentBoundingBoxInPx()?.top"
    [style.width]="parentBoundingBoxInPx()?.width"
    [style.height]="parentBoundingBoxInPx()?.height"
  ></div>
  <div
    #popover
    class="border-lav fixed z-50 overflow-hidden rounded-md border-[1px] border-solid bg-white shadow-md"
    [style.left]="positionLeftAsString()"
    [style.top]="positionTopAsString()"
    [style.visibility]="menuVisible"
    (click)="stopPropagation($event)"
  >
    <ng-content></ng-content>
  </div>
</div>
